// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { ContextStore, RouteStore } from 'bernie-core';

import { UiStore } from 'stores';
import { UitkSpacing } from 'uitk-react-spacing';
import { FlexDocumentDialog } from 'components/documents/flex-document-dialog';

export interface FlexDocumentProps {
  context?: ContextStore;
  routeStore?: RouteStore;
  uiStore?: UiStore;
  documentName: string;
}

@inject('context', 'routeStore', 'uiStore')
export class FlexDocument extends React.Component<FlexDocumentProps, any> {
  constructor(props) {
    super(props);
  }

  public componentDidMount() {
    this.props.routeStore.updateSearch({ pwaDialog: 'flex-document-dialog' });
  }

  public render() {
    const { uiStore } = this.props;

    const documentName = uiStore?.documentName;
    const iframeUrl = uiStore?.flexDocuments[documentName];

    const locale = this.props.context.locale;
    const url = `${iframeUrl}?siteid=2055&locale=${locale}`;
    const headerName =
      {
        'terms-of-use': 'terms.page.title',
        'privacy-policy': 'privacy.policy.page.title',
        'cookie-policy': 'cookie.policy.page.title',
      }[documentName] || '';

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <FlexDocumentDialog url={url} headerName={headerName} />
      </UitkSpacing>
    );
  }
}
